{
  "until": "{{duration}} kafin {{prayer}}",
  "begin_focus": "Fara maida hankali",
  "add_task": "Ƙara aiki",
  "more_tasks": "+{{count}} ƙari",
  "fajr_at": "Asuba da {{time}}",
  "schedule_title": "Yau",
  "plan_my_day": "Tsara ranata",
  "planning": "Ana tsarawa…",
  "suggested": "Shawara",
  "keep_plan": "Riƙe tsarin",
  "undo_plan": "Mayar",
  "plan_error": "Ba a iya tsarawa yanzu ba. Sake gwadawa.",
  "plan_empty": "Babu abin tsarawa tukuna — fara ƙara aiki.",
  "plan_settled": "Komai yana wurinsa tuni.",
  "view_list": "Jerin",
  "view_switch_aria": "Sauya tsakanin jerin da kallon rana",
  "unassigned": "Ba a tsara ba",
  "assign_title": "Sashen sallah",
  "no_block": "Babu sashe",
  "assign_aria": "Sanya a sashen sallah",
  "open_schedule_aria": "Buɗe jadawalin yau",
  "focus_session_label": "{{block}} · Maida hankali",
  "block_hero": "Aiki mai zurfi har {{prayer}}",
  "moments_away": "{{prayer}} tana gab da zuwa",
  "block_clear": "An gama komai — huta har {{prayer}}",
  "alhamdulillah": "Alhamdulillah",
  "exit_hint": "Danna Esc don fita a hankali",
  "exit_hint_touch": "Danna ✕ don fita a hankali",
  "mark_done_aria": "Yi alamar an gama aikin",
  "quick_add_placeholder": "Ƙara a wannan sashen…",
  "focus_task_aria": "Maida hankali kan wannan aikin"
}
